import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_register_account_modal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog mw-1000px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h2", null, "Register with SEALPRO", -1)
const _hoisted_6 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body scroll-y m-5" }
const _hoisted_9 = {
  ref: "createAccountRef",
  class: "stepper stepper-links d-flex flex-column",
  id: "kt_create_account_stepper"
}
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"stepper-nav py-5\"><div class=\"stepper-item current\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\"> Account Info </h3></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\"> Insurance Info </h3></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\"> Activation Info </h3></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\"> Confirmation </h3></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\"> Completed </h3></div></div>", 1)
const _hoisted_11 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_12 = { class: "w-100" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "pb-10 pb-lg-15" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-gray-400 fw-bold fs-6" }, " Please fill-up all the information correctly. ")
], -1)
const _hoisted_14 = { class: "row mb-10" }
const _hoisted_15 = { class: "col-md-6 fv-row" }
const _hoisted_16 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_17 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "First Name"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Your First Name"
  })
], -1)
const _hoisted_18 = { class: "position-relative" }
const _hoisted_19 = { class: "fv-plugins-message-container" }
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "col-md-6 fv-row" }
const _hoisted_22 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_23 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", null, "Middle Name")
], -1)
const _hoisted_24 = { class: "fv-plugins-message-container" }
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = { class: "col-md-6 fv-row" }
const _hoisted_27 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_28 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Last Name", -1)
const _hoisted_29 = { class: "position-relative" }
const _hoisted_30 = { class: "fv-plugins-message-container" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = { class: "col-md-6 fv-row" }
const _hoisted_33 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_34 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Birth Date", -1)
const _hoisted_35 = { class: "position-relative" }
const _hoisted_36 = { class: "fv-plugins-message-container" }
const _hoisted_37 = { class: "fv-help-block" }
const _hoisted_38 = { class: "col-md-6 fv-row" }
const _hoisted_39 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_40 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Country of Nationality", -1)
const _hoisted_41 = { class: "position-relative" }
const _hoisted_42 = { class: "fv-plugins-message-container" }
const _hoisted_43 = { class: "fv-help-block" }
const _hoisted_44 = { class: "col-md-6 fv-row" }
const _hoisted_45 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_46 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Job Classification", -1)
const _hoisted_47 = { class: "position-relative" }
const _hoisted_48 = { class: "fv-plugins-message-container" }
const _hoisted_49 = { class: "fv-help-block" }
const _hoisted_50 = { class: "row mb-10" }
const _hoisted_51 = { class: "col-md-12 fv-row" }
const _hoisted_52 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Account Access", -1)
const _hoisted_53 = { class: "row fv-row" }
const _hoisted_54 = { class: "col-12" }
const _hoisted_55 = { class: "fv-plugins-message-container" }
const _hoisted_56 = { class: "fv-help-block" }
const _hoisted_57 = { class: "col-6" }
const _hoisted_58 = { class: "fv-plugins-message-container" }
const _hoisted_59 = { class: "fv-help-block" }
const _hoisted_60 = /*#__PURE__*/_createVNode("div", { class: "fs-7 fw-bold text-gray-400" }, " Password ", -1)
const _hoisted_61 = { class: "col-6" }
const _hoisted_62 = { class: "fv-plugins-message-container" }
const _hoisted_63 = { class: "fv-help-block" }
const _hoisted_64 = /*#__PURE__*/_createVNode("div", { class: "fs-7 fw-bold text-gray-400" }, " Confirm Password ", -1)
const _hoisted_65 = { class: "row mb-10" }
const _hoisted_66 = { class: "col-md-12 fv-row" }
const _hoisted_67 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Sponsor Info", -1)
const _hoisted_68 = { class: "row fv-row" }
const _hoisted_69 = { class: "col-6" }
const _hoisted_70 = { class: "fv-plugins-message-container" }
const _hoisted_71 = { class: "fv-help-block" }
const _hoisted_72 = { class: "col-6" }
const _hoisted_73 = { class: "fv-plugins-message-container" }
const _hoisted_74 = { class: "fv-help-block" }
const _hoisted_75 = { class: "col-6" }
const _hoisted_76 = /*#__PURE__*/_createVNode("option", null, "Select Position", -1)
const _hoisted_77 = /*#__PURE__*/_createVNode("option", {
  label: "Left",
  value: "L"
}, "Left", -1)
const _hoisted_78 = /*#__PURE__*/_createVNode("option", {
  label: "Right",
  value: "R"
}, "Right", -1)
const _hoisted_79 = { class: "fv-plugins-message-container" }
const _hoisted_80 = { class: "fv-help-block" }
const _hoisted_81 = /*#__PURE__*/_createVNode("div", { class: "fs-7 fw-bold text-gray-400" }, " Position ", -1)
const _hoisted_82 = { "data-kt-stepper-element": "content" }
const _hoisted_83 = { class: "w-100" }
const _hoisted_84 = /*#__PURE__*/_createVNode("div", { class: "pb-10 pb-lg-15" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-gray-400 fw-bold fs-6" }, " Below are the details for your Insurance coverage ")
], -1)
const _hoisted_85 = { class: "row mb-10" }
const _hoisted_86 = { class: "col-md-6 fv-row" }
const _hoisted_87 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_88 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Mobile Number", -1)
const _hoisted_89 = { class: "position-relative" }
const _hoisted_90 = { class: "fv-plugins-message-container" }
const _hoisted_91 = { class: "fv-help-block" }
const _hoisted_92 = { class: "col-md-6 fv-row" }
const _hoisted_93 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_94 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Email", -1)
const _hoisted_95 = { class: "position-relative" }
const _hoisted_96 = { class: "fv-plugins-message-container" }
const _hoisted_97 = { class: "fv-help-block" }
const _hoisted_98 = /*#__PURE__*/_createVNode("div", { class: "pb-3 pb-lg-5" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-gray-400 fw-bold fs-6" }, " Your address ")
], -1)
const _hoisted_99 = { class: "col-md-6 fv-row" }
const _hoisted_100 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_101 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Block Number and Street", -1)
const _hoisted_102 = { class: "position-relative" }
const _hoisted_103 = { class: "fv-plugins-message-container" }
const _hoisted_104 = { class: "fv-help-block" }
const _hoisted_105 = { class: "col-md-6 fv-row" }
const _hoisted_106 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_107 = /*#__PURE__*/_createVNode("label", { class: "fs-6 fw-bold form-label mb-2" }, "Name of Building(Optional)", -1)
const _hoisted_108 = { class: "position-relative" }
const _hoisted_109 = { class: "fv-plugins-message-container" }
const _hoisted_110 = { class: "fv-help-block" }
const _hoisted_111 = { class: "col-md-6 fv-row" }
const _hoisted_112 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_113 = /*#__PURE__*/_createVNode("label", { class: " fs-6 fw-bold form-label mb-2" }, "Unit Number (Optional)", -1)
const _hoisted_114 = { class: "position-relative" }
const _hoisted_115 = { class: "fv-plugins-message-container" }
const _hoisted_116 = { class: "fv-help-block" }
const _hoisted_117 = { class: "col-md-6 fv-row" }
const _hoisted_118 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_119 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "City", -1)
const _hoisted_120 = { class: "position-relative" }
const _hoisted_121 = { class: "fv-plugins-message-container" }
const _hoisted_122 = { class: "fv-help-block" }
const _hoisted_123 = { class: "col-md-6 fv-row" }
const _hoisted_124 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_125 = /*#__PURE__*/_createVNode("label", { class: " fs-6 fw-bold form-label mb-2" }, "Postal Code", -1)
const _hoisted_126 = { class: "position-relative" }
const _hoisted_127 = { class: "fv-plugins-message-container" }
const _hoisted_128 = { class: "fv-help-block" }
const _hoisted_129 = { class: "col-md-6 fv-row" }
const _hoisted_130 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_131 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Country", -1)
const _hoisted_132 = { class: "position-relative" }
const _hoisted_133 = { class: "fv-plugins-message-container" }
const _hoisted_134 = { class: "fv-help-block" }
const _hoisted_135 = { class: "col-md-6 fv-row" }
const _hoisted_136 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_137 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Province", -1)
const _hoisted_138 = { class: "position-relative" }
const _hoisted_139 = { class: "fv-plugins-message-container" }
const _hoisted_140 = { class: "fv-help-block" }
const _hoisted_141 = /*#__PURE__*/_createVNode("div", { class: "pb-3 pb-lg-5" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-gray-400 fw-bold fs-6" }, " Beneficiary Details ")
], -1)
const _hoisted_142 = { class: "row mb-10" }
const _hoisted_143 = { class: "col-md-6 fv-row" }
const _hoisted_144 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_145 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Beneficiary First Name"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Beneficiary First Name"
  })
], -1)
const _hoisted_146 = { class: "fv-plugins-message-container" }
const _hoisted_147 = { class: "fv-help-block" }
const _hoisted_148 = { class: "col-md-6 fv-row" }
const _hoisted_149 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_150 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Beneficiary Middle Name"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Beneficiary Middle Name"
  })
], -1)
const _hoisted_151 = { class: "fv-plugins-message-container" }
const _hoisted_152 = { class: "fv-help-block" }
const _hoisted_153 = { class: "col-md-6 fv-row" }
const _hoisted_154 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_155 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Beneficiary Last Name", -1)
const _hoisted_156 = { class: "position-relative" }
const _hoisted_157 = { class: "fv-plugins-message-container" }
const _hoisted_158 = { class: "fv-help-block" }
const _hoisted_159 = { class: "col-md-6 fv-row" }
const _hoisted_160 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_161 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Beneficiary Birth Date", -1)
const _hoisted_162 = { class: "position-relative" }
const _hoisted_163 = { class: "fv-plugins-message-container" }
const _hoisted_164 = { class: "fv-help-block" }
const _hoisted_165 = { class: "col-md-6 fv-row" }
const _hoisted_166 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_167 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Beneficiary Mobile Number", -1)
const _hoisted_168 = { class: "position-relative" }
const _hoisted_169 = { class: "fv-plugins-message-container" }
const _hoisted_170 = { class: "fv-help-block" }
const _hoisted_171 = { class: "col-md-6 fv-row" }
const _hoisted_172 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_173 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Relationship With Insured", -1)
const _hoisted_174 = { class: "position-relative" }
const _hoisted_175 = /*#__PURE__*/_createVNode("option", null, "Select Relationship", -1)
const _hoisted_176 = /*#__PURE__*/_createVNode("option", {
  label: "Spouse",
  value: "Spouse"
}, "Spouse", -1)
const _hoisted_177 = /*#__PURE__*/_createVNode("option", {
  label: "Child",
  value: "Child"
}, "Child", -1)
const _hoisted_178 = /*#__PURE__*/_createVNode("option", {
  label: "Parent",
  value: "Parent"
}, "Parent", -1)
const _hoisted_179 = /*#__PURE__*/_createVNode("option", {
  label: "Sibling",
  value: "Sibling"
}, "Sibling", -1)
const _hoisted_180 = /*#__PURE__*/_createVNode("option", {
  label: "Others (Blood-related, Relative)",
  value: "Others"
}, "Others (Blood-related, Relative)", -1)
const _hoisted_181 = { class: "fv-plugins-message-container" }
const _hoisted_182 = { class: "fv-help-block" }
const _hoisted_183 = { class: "col-md-12 fv-row" }
const _hoisted_184 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_185 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Terms and Conditions", -1)
const _hoisted_186 = { class: "position-relative" }
const _hoisted_187 = /*#__PURE__*/_createVNode("p", null, "By activating the code, you are confirming that you have taken the time to read, comprehend, and review the terms and conditions outlined in the linked insurance policy and that you hereby acknowledge that you understood, and agreed to the terms and conditions of the said insurance policy including the general exclusions, claim requirements, and other sections of the policy.", -1)
const _hoisted_188 = /*#__PURE__*/_createVNode("p", null, "By activating the code, you also confirm that the personal information that you submitted are true and correct of your own knowledge. ", -1)
const _hoisted_189 = /*#__PURE__*/_createVNode("p", null, "By activating the code, you hereby authorize Orbix Victus International Inc. & Stronghold Insurance Company Inc. to collect and store your data. Data such as but not limited to, your full name, nationality, mobile number, and other relevant information, using electronic or automated means, shall be stored within the period allowed under applicable laws, rules and regulations, for the purpose of processing your insurance policy.", -1)
const _hoisted_190 = { class: "row mb-5 mt-5" }
const _hoisted_191 = { class: "form-check-label col-md-10" }
const _hoisted_192 = /*#__PURE__*/_createVNode("span", { class: "form-check-sign" }, null, -1)
const _hoisted_193 = /*#__PURE__*/_createTextVNode(" I have read the Terms and Conditions. I agree and I want to proceed! ")
const _hoisted_194 = { "data-kt-stepper-element": "content" }
const _hoisted_195 = { class: "w-100" }
const _hoisted_196 = /*#__PURE__*/_createVNode("div", { class: "pb-10 pb-lg-15" }, [
  /*#__PURE__*/_createVNode("h2", { class: "fw-bolder d-flex align-items-center text-dark" }, [
    /*#__PURE__*/_createTextVNode(" Enter Activation code "),
    /*#__PURE__*/_createVNode("i", {
      class: "fas fa-exclamation-circle ms-2 fs-7",
      "data-bs-toggle": "tooltip"
    })
  ]),
  /*#__PURE__*/_createVNode("div", { class: "text-gray-400 fw-bold fs-6" }, " Activation code can be found in the scratch card inside your package ")
], -1)
const _hoisted_197 = { class: "row mb-10" }
const _hoisted_198 = { class: "col-md-6 fv-row" }
const _hoisted_199 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_200 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "User ID"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: ""
  })
], -1)
const _hoisted_201 = { class: "fv-plugins-message-container" }
const _hoisted_202 = { class: "fv-help-block" }
const _hoisted_203 = { class: "col-md-6 fv-row" }
const _hoisted_204 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_205 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "PIN"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: ""
  })
], -1)
const _hoisted_206 = { class: "fv-plugins-message-container" }
const _hoisted_207 = { class: "fv-help-block" }
const _hoisted_208 = { "data-kt-stepper-element": "content" }
const _hoisted_209 = { class: "w-100" }
const _hoisted_210 = { class: "mb-0" }
const _hoisted_211 = {
  key: 0,
  class: "notice d-flex bg-light-warning rounded border-warning border border-dashed p-6"
}
const _hoisted_212 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_213 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-stack flex-grow-1\"><div class=\"fw-bold\"><h4 class=\"text-gray-800 fw-bolder\"> Please wait... verifying data... </h4><div class=\"fs-6 text-gray-600\"><a href=\"javascript:;\" class=\"fw-bolder\"></a></div></div></div>", 1)
const _hoisted_214 = /*#__PURE__*/_createStaticVNode("<div data-kt-stepper-element=\"content\"><div class=\"w-100 text-center\"><h1 class=\"fw-bolder text-dark mb-3\"></h1><div class=\"text-muted fw-bold fs-3\"> Submitting your application. Please wait </div><div class=\"text-center px-4 py-15\"><img src=\"media/illustrations/todo.png\" alt=\"\" class=\"mw-100 mh-150px\"></div></div></div>", 1)
const _hoisted_215 = { class: "d-flex flex-stack pt-15" }
const _hoisted_216 = { class: "me-2" }
const _hoisted_217 = { class: "svg-icon svg-icon-3 me-1" }
const _hoisted_218 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_219 = { key: 0 }
const _hoisted_220 = { class: "indicator-label" }
const _hoisted_221 = /*#__PURE__*/_createTextVNode(" Submit ")
const _hoisted_222 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_223 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_224 = {
  key: 1,
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_225 = /*#__PURE__*/_createTextVNode(" Continue ")
const _hoisted_226 = { class: "svg-icon svg-icon-3 ms-1 me-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_Field = _resolveComponent("Field")
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_ConfirmRegister = _resolveComponent("ConfirmRegister")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("div", _hoisted_6, [
            _createVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
            ])
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode("form", {
              class: "mx-auto mw-600px w-100 py-10",
              novalidate: "novalidate",
              id: "kt_create_account_form",
              onSubmit: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
            }, [
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode("div", _hoisted_14, [
                    _createVNode("div", _hoisted_15, [
                      _createVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createVNode("div", _hoisted_18, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "insured_firstName"
                          }),
                          _createVNode("div", _hoisted_19, [
                            _createVNode("div", _hoisted_20, [
                              _createVNode(_component_ErrorMessage, { name: "insured_firstName" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_21, [
                      _createVNode("div", _hoisted_22, [
                        _hoisted_23,
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control form-control-solid",
                          placeholder: "",
                          name: "insured_middleName",
                          maxlength: "50"
                        }),
                        _createVNode("div", _hoisted_24, [
                          _createVNode("div", _hoisted_25, [
                            _createVNode(_component_ErrorMessage, { name: "insured_middleName" })
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_26, [
                      _createVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createVNode("div", _hoisted_29, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "insured_lastName"
                          }),
                          _createVNode("div", _hoisted_30, [
                            _createVNode("div", _hoisted_31, [
                              _createVNode(_component_ErrorMessage, { name: "insured_lastName" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_32, [
                      _createVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createVNode("div", _hoisted_35, [
                          _createVNode(_component_Field, {
                            type: "date",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "insured_birthday",
                            format: "DD/MM/yyyy"
                          }),
                          _createVNode("div", _hoisted_36, [
                            _createVNode("div", _hoisted_37, [
                              _createVNode(_component_ErrorMessage, { name: "insured_birthday" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_38, [
                      _createVNode("div", _hoisted_39, [
                        _hoisted_40,
                        _createVNode("div", _hoisted_41, [
                          _createVNode(_component_Field, {
                            name: "address_country2",
                            modelValue: _ctx.address_country2,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.address_country2 = $event)),
                            class: "form-select form-select-lg form-select-solid",
                            as: "select"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.countries, (i) => {
                                return (_openBlock(), _createBlock("option", {
                                  key: i,
                                  label: i.name,
                                  value: i.country_id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_42, [
                            _createVNode("div", _hoisted_43, [
                              _createVNode(_component_ErrorMessage, { name: "address_country2" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_44, [
                      _createVNode("div", _hoisted_45, [
                        _hoisted_46,
                        _createVNode("div", _hoisted_47, [
                          _createVNode(_component_Field, {
                            name: "job_classification",
                            modelValue: _ctx.job_classification,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.job_classification = $event)),
                            class: "form-select form-select-lg form-select-solid",
                            as: "select"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.job_classification_options_list, (i) => {
                                return (_openBlock(), _createBlock("option", {
                                  key: i,
                                  label: i.name,
                                  value: i.job_classification_id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_48, [
                            _createVNode("div", _hoisted_49, [
                              _createVNode(_component_ErrorMessage, { name: "job_classification" })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_50, [
                    _createVNode("div", _hoisted_51, [
                      _hoisted_52,
                      _createVNode("div", _hoisted_53, [
                        _createVNode("div", _hoisted_54, [
                          _createVNode(_component_Field, {
                            name: "username",
                            class: "form-control form-control-solid",
                            type: "text",
                            placeholder: "Username"
                          }),
                          _createVNode("div", _hoisted_55, [
                            _createVNode("div", _hoisted_56, [
                              _createVNode(_component_ErrorMessage, { name: "username" })
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_57, [
                          _createVNode(_component_Field, {
                            name: "password",
                            class: "form-control form-control-solid",
                            type: "password",
                            placeholder: "Password"
                          }),
                          _createVNode("div", _hoisted_58, [
                            _createVNode("div", _hoisted_59, [
                              _createVNode(_component_ErrorMessage, { name: "password" })
                            ])
                          ]),
                          _hoisted_60
                        ]),
                        _createVNode("div", _hoisted_61, [
                          _createVNode(_component_Field, {
                            name: "cpassword",
                            class: "form-control form-control-solid",
                            type: "password",
                            placeholder: "Confirm Password"
                          }),
                          _createVNode("div", _hoisted_62, [
                            _createVNode("div", _hoisted_63, [
                              _createVNode(_component_ErrorMessage, { name: "cpassword" })
                            ])
                          ]),
                          _hoisted_64
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_65, [
                    _createVNode("div", _hoisted_66, [
                      _hoisted_67,
                      _createVNode("div", _hoisted_68, [
                        _createVNode("div", _hoisted_69, [
                          _createVNode(_component_Field, {
                            name: "sponsorid",
                            class: "form-control form-control-solid",
                            type: "text",
                            placeholder: "Sponsor ID"
                          }),
                          _createVNode("div", _hoisted_70, [
                            _createVNode("div", _hoisted_71, [
                              _createVNode(_component_ErrorMessage, { name: "sponsorid" })
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_72, [
                          _createVNode(_component_Field, {
                            name: "uplineid",
                            class: "form-control form-control-solid",
                            type: "text",
                            placeholder: "Upline ID",
                            readonly: _ctx.isDisabledUPID
                          }, null, 8, ["readonly"]),
                          _createVNode("div", _hoisted_73, [
                            _createVNode("div", _hoisted_74, [
                              _createVNode(_component_ErrorMessage, { name: "uplineid" })
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_75, [
                          _createVNode(_component_Field, {
                            name: "position",
                            class: "form-select form-select-lg form-select-solid",
                            as: "select",
                            disabled: _ctx.isDisabledUPID
                          }, {
                            default: _withCtx(() => [
                              _hoisted_76,
                              _hoisted_77,
                              _hoisted_78
                            ]),
                            _: 1
                          }, 8, ["disabled"]),
                          _createVNode("div", _hoisted_79, [
                            _createVNode("div", _hoisted_80, [
                              _createVNode(_component_ErrorMessage, { name: "position" })
                            ])
                          ]),
                          _hoisted_81
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_82, [
                _createVNode("div", _hoisted_83, [
                  _hoisted_84,
                  _createVNode("div", _hoisted_85, [
                    _createVNode("div", _hoisted_86, [
                      _createVNode("div", _hoisted_87, [
                        _hoisted_88,
                        _createVNode("div", _hoisted_89, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "insured_mobileNumber"
                          }),
                          _createVNode("div", _hoisted_90, [
                            _createVNode("div", _hoisted_91, [
                              _createVNode(_component_ErrorMessage, { name: "insured_mobileNumber" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_92, [
                      _createVNode("div", _hoisted_93, [
                        _hoisted_94,
                        _createVNode("div", _hoisted_95, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "insured_email",
                            onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"]))
                          }),
                          _createVNode("div", _hoisted_96, [
                            _createVNode("div", _hoisted_97, [
                              _createVNode(_component_ErrorMessage, { name: "insured_email" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _hoisted_98,
                    _createVNode("div", _hoisted_99, [
                      _createVNode("div", _hoisted_100, [
                        _hoisted_101,
                        _createVNode("div", _hoisted_102, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "address_blockAndStreet",
                            maxlength: "100"
                          }),
                          _createVNode("div", _hoisted_103, [
                            _createVNode("div", _hoisted_104, [
                              _createVNode(_component_ErrorMessage, { name: "address_blockAndStreet" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_105, [
                      _createVNode("div", _hoisted_106, [
                        _hoisted_107,
                        _createVNode("div", _hoisted_108, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "address_nameOfBuilding"
                          }),
                          _createVNode("div", _hoisted_109, [
                            _createVNode("div", _hoisted_110, [
                              _createVNode(_component_ErrorMessage, { name: "address_nameOfBuilding" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_111, [
                      _createVNode("div", _hoisted_112, [
                        _hoisted_113,
                        _createVNode("div", _hoisted_114, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "address_unitNumber"
                          }),
                          _createVNode("div", _hoisted_115, [
                            _createVNode("div", _hoisted_116, [
                              _createVNode(_component_ErrorMessage, { name: "address_unitNumber" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_117, [
                      _createVNode("div", _hoisted_118, [
                        _hoisted_119,
                        _createVNode("div", _hoisted_120, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "address_city"
                          }),
                          _createVNode("div", _hoisted_121, [
                            _createVNode("div", _hoisted_122, [
                              _createVNode(_component_ErrorMessage, { name: "address_city" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_123, [
                      _createVNode("div", _hoisted_124, [
                        _hoisted_125,
                        _createVNode("div", _hoisted_126, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "address_postalCode"
                          }),
                          _createVNode("div", _hoisted_127, [
                            _createVNode("div", _hoisted_128, [
                              _createVNode(_component_ErrorMessage, { name: "address_postalCode" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_129, [
                      _createVNode("div", _hoisted_130, [
                        _hoisted_131,
                        _createVNode("div", _hoisted_132, [
                          _createVNode(_component_Field, {
                            name: "address_country",
                            modelValue: _ctx.address_country,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.address_country = $event)),
                            class: "form-select form-select-lg form-select-solid",
                            as: "select",
                            onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getCities(_ctx.address_country)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countries) + " ", 1),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.countries, (i) => {
                                return (_openBlock(), _createBlock("option", {
                                  key: i,
                                  label: i.name,
                                  value: i.country_id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_133, [
                            _createVNode("div", _hoisted_134, [
                              _createVNode(_component_ErrorMessage, { name: "address_country" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_135, [
                      _createVNode("div", _hoisted_136, [
                        _hoisted_137,
                        _createVNode("div", _hoisted_138, [
                          _createVNode(_component_Field, {
                            name: "address_province",
                            class: "form-select form-select-lg form-select-solid",
                            as: "select"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cities, (i) => {
                                return (_openBlock(), _createBlock("option", {
                                  key: i,
                                  label: i.name,
                                  value: i.zone_id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }),
                          _createVNode("div", _hoisted_139, [
                            _createVNode("div", _hoisted_140, [
                              _createVNode(_component_ErrorMessage, { name: "address_province" })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_141,
                  _createVNode("div", _hoisted_142, [
                    _createVNode("div", _hoisted_143, [
                      _createVNode("div", _hoisted_144, [
                        _hoisted_145,
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control form-control-solid",
                          placeholder: "",
                          name: "beneficiary_firstName",
                          maxlength: "50"
                        }),
                        _createVNode("div", _hoisted_146, [
                          _createVNode("div", _hoisted_147, [
                            _createVNode(_component_ErrorMessage, { name: "beneficiary_firstName" })
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_148, [
                      _createVNode("div", _hoisted_149, [
                        _hoisted_150,
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control form-control-solid",
                          placeholder: "",
                          name: "beneficiary_middleName",
                          maxlength: "50"
                        }),
                        _createVNode("div", _hoisted_151, [
                          _createVNode("div", _hoisted_152, [
                            _createVNode(_component_ErrorMessage, { name: "beneficiary_middleName" })
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_153, [
                      _createVNode("div", _hoisted_154, [
                        _hoisted_155,
                        _createVNode("div", _hoisted_156, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "beneficiary_lastName"
                          }),
                          _createVNode("div", _hoisted_157, [
                            _createVNode("div", _hoisted_158, [
                              _createVNode(_component_ErrorMessage, { name: "beneficiary_lastName" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_159, [
                      _createVNode("div", _hoisted_160, [
                        _hoisted_161,
                        _createVNode("div", _hoisted_162, [
                          _createVNode(_component_Field, {
                            type: "date",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "beneficiary_birthday"
                          }),
                          _createVNode("div", _hoisted_163, [
                            _createVNode("div", _hoisted_164, [
                              _createVNode(_component_ErrorMessage, { name: "beneficiary_birthday" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_165, [
                      _createVNode("div", _hoisted_166, [
                        _hoisted_167,
                        _createVNode("div", _hoisted_168, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "beneficiary_contact"
                          }),
                          _createVNode("div", _hoisted_169, [
                            _createVNode("div", _hoisted_170, [
                              _createVNode(_component_ErrorMessage, { name: "beneficiary_contact" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_171, [
                      _createVNode("div", _hoisted_172, [
                        _hoisted_173,
                        _createVNode("div", _hoisted_174, [
                          _createVNode(_component_Field, {
                            name: "beneficiary_relationship",
                            class: "form-select form-select-lg form-select-solid",
                            as: "select"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_175,
                              _hoisted_176,
                              _hoisted_177,
                              _hoisted_178,
                              _hoisted_179,
                              _hoisted_180
                            ]),
                            _: 1
                          }),
                          _createVNode("div", _hoisted_181, [
                            _createVNode("div", _hoisted_182, [
                              _createVNode(_component_ErrorMessage, { name: "beneficiary_relationship" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_183, [
                      _createVNode("div", _hoisted_184, [
                        _hoisted_185,
                        _createVNode("div", _hoisted_186, [
                          _hoisted_187,
                          _hoisted_188,
                          _hoisted_189,
                          _createVNode("div", _hoisted_190, [
                            _createVNode("label", _hoisted_191, [
                              _createVNode("input", {
                                class: "form-check-input",
                                id: "checkbox4",
                                type: "checkbox",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.checkBoxValidator($event);})
                              }),
                              _hoisted_192,
                              _hoisted_193
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_194, [
                _createVNode("div", _hoisted_195, [
                  _hoisted_196,
                  _createVNode("div", _hoisted_197, [
                    _createVNode("div", _hoisted_198, [
                      _createVNode("div", _hoisted_199, [
                        _hoisted_200,
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control form-control-solid",
                          placeholder: "",
                          name: "userid",
                          maxlength: "20"
                        }),
                        _createVNode("div", _hoisted_201, [
                          _createVNode("div", _hoisted_202, [
                            _createVNode(_component_ErrorMessage, { name: "userid" })
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_203, [
                      _createVNode("div", _hoisted_204, [
                        _hoisted_205,
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control form-control-solid",
                          placeholder: "",
                          name: "securitypin",
                          maxlength: "20"
                        }),
                        _createVNode("div", _hoisted_206, [
                          _createVNode("div", _hoisted_207, [
                            _createVNode(_component_ErrorMessage, { name: "securitypin" })
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_208, [
                _createVNode("div", _hoisted_209, [
                  _createVNode("div", _hoisted_210, [
                    (_ctx.formData.verifyingdata)
                      ? (_openBlock(), _createBlock("div", _hoisted_211, [
                          _createVNode("span", _hoisted_212, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
                          ]),
                          _hoisted_213
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.formData.verifyingdata === false)
                      ? (_openBlock(), _createBlock(_component_ConfirmRegister, {
                          key: 1,
                          formdata: _ctx.formData
                        }, null, 8, ["formdata"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _hoisted_214,
              _createVNode("div", _hoisted_215, [
                _createVNode("div", _hoisted_216, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn btn-lg btn-light-primary me-3",
                    "data-kt-stepper-action": "previous",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.previousStep()))
                  }, [
                    _createVNode("span", _hoisted_217, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Left-2.svg" })
                    ]),
                    _hoisted_218
                  ])
                ]),
                (_ctx.formData.verifyingdata === false && _ctx.currentStepIndex !== (_ctx.totalSteps -1))
                  ? (_openBlock(), _createBlock("div", _hoisted_219, [
                      (_ctx.currentStepIndex === _ctx.totalSteps - 2)
                        ? (_openBlock(), _createBlock("button", {
                            key: 0,
                            type: "submit",
                            class: "btn btn-lg btn-primary",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.formSubmit()))
                          }, [
                            _createVNode("span", _hoisted_220, [
                              _hoisted_221,
                              _createVNode("span", _hoisted_222, [
                                _createVNode(_component_inline_svg, { src: "icons/duotone/Navigation/Right-2.svg" })
                              ])
                            ]),
                            _hoisted_223
                          ]))
                        : _createCommentVNode("", true),
                      ((_ctx.currentStepIndex == 1 && _ctx.formData.istncchecked == true) || _ctx.currentStepIndex != 1 && _ctx.currentStepIndex != 3)
                        ? (_openBlock(), _createBlock("button", _hoisted_224, [
                            _hoisted_225,
                            _createVNode("span", _hoisted_226, [
                              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Right-2.svg" })
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 32)
          ], 512)
        ])
      ])
    ])
  ]))
}